import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { RuleEditorModule } from "@comunicare/comunicare-rule-editor";
import { TranslateModule } from "@ngx-translate/core";
import { RuleEditorContainerPageComponent } from "./rule-editor-container-page.component";

@NgModule({
  declarations: [RuleEditorContainerPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RuleEditorModule,
    RouterModule.forChild([{ path: "", component: RuleEditorContainerPageComponent }]),
  ],
  exports: [RuleEditorContainerPageComponent],
})
export class RuleEditorContainerPageModule {}
